<script lang="ts">
        import ProductDetails from '$lib/components/ProductDetails.svelte';
        import ProductGuarantee from '$lib/components/ProductGuarantee.svelte';
        import ProductHero from '$lib/components/ProductHero.svelte';
	import PageContainer from '$lib/components/PageContainer.svelte';
        import type { PageData } from './$types';

        let { data }: { data: PageData } = $props();

        const product = data.config.product;
</script>

<svelte:head>
	{#if data.config.product}
		<title>{product.name} - {data.config.displayName}</title>
		<meta name="description" content="{product.description}" />
		<meta property="og:title" content="{product.name} - {data.config.displayName}" />
		<meta property="og:description" content="{product.description}" />
		{#if product.imageUrl}
			<meta property="og:image" content="{product.imageUrl}" />
		{/if}
		<meta property="og:type" content="product" />
		<meta property="product:price:amount" content="{product.price}" />
		<meta property="product:price:currency" content="{product.currency}" />
	{:else}
		<title>Product Not Found - {data.config.displayName}</title>
		<meta name="description" content="The requested product is not available." />
	{/if}
</svelte:head>

{#if data.config.product}
	<!-- JSON-LD Product Schema -->
	<script type="application/ld+json">
		{
			"@context": "https://schema.org",
			"@type": "Product",
			"name": "{product.name}",
			"description": "{product.description}",
			"offers": {
				"@type": "Offer",
				"price": "{product.price}",
				"priceCurrency": "{product.currency}",
				"url": "{product.checkoutUrl}",
				"availability": "https://schema.org/InStock"
			}
			{#if product.imageUrl}
			,"image": "{product.imageUrl}"
			{/if}
		}
	</script>
{/if}

{#if data.config.product}
	<PageContainer config={data.config}>
                        <ProductHero {product} />

                        <ProductDetails {product} />

                        <ProductGuarantee {product} refundsUrl={data.config.links.refunds} />
	</PageContainer>
{:else}
	<PageContainer config={data.config}>
		<div class="error-content">
			<h1>Error</h1>
			<p>Something Went Wrong</p>
			<p>The product you're looking for is not available.</p>
			<a href="/" class="home-link">Return to Home</a>
		</div>
	</PageContainer>
{/if}

<style lang="scss">
	@use "$lib/scss/_mixins.scss" as *;
	@use "$lib/scss/_themes.scss" as *;

        .error-content {
                text-align: center;
                padding: 2rem;
        }

	.error-content h1 {
		font-size: 2.5rem;
		color: var(--brand-primary);
		margin-bottom: 1rem;
	}

	.error-content p {
		font-size: 1.25rem;
		color: #64748b;
		margin-bottom: 2rem;
	}

	.home-link {
		display: inline-block;
		background: var(--brand-primary);
		color: white;
		padding: 1rem 2rem;
		font-size: 1.1rem;
		font-weight: 600;
		text-decoration: none;
		border-radius: 8px;
		transition: all 0.3s ease;
	}

	.home-link:hover {
		background: var(--brand-secondary);
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
	}
</style>